export const CHANGE_LANGUAGE = "CHANGE_LANGUAGE";
export const SET_DEFAULT_LANGUAGE = "SET_DEFAULT_LANGUAGE";
export const SET_AVAILABLE_LANGUAGES = "SET_AVAILABLE_LANGUAGES";